module.exports = __webpack_public_path__ + "static/media/menu.3e08559c.svg";